/**
 * Header Component
 * Main header with logo, navigation, and social elements
 */
import { Suspense, lazy } from 'react';
import { BRAND_CONFIG } from '../../config/brand';
import MobileNavigation from './MobileNavigation';
import DesktopNavigation from './DesktopNavigation';
import { navigateToSection } from '../../utils/navigation';

// Lazy load non-critical components
const SocialBar = lazy(() => import('../SocialBar'));
const StoreOpenBanner = lazy(() => import('../StoreOpenBanner'));

const Header = ({ isMobile }) => {
  return (
    <header className="relative top-0 z-50">
      <link
        rel="preload"
        as="image"
        href={BRAND_CONFIG.animatedEmoji.props.src}
      />
      <nav className="flex flex-col">
        <div className="container mx-0 flex w-full max-w-full min-w-full items-center justify-between bg-zinc-950/80 px-0 py-2 backdrop-blur md:bg-zinc-950/80 md:py-6 md:pr-[10vw] md:pl-[10vw]">
          <div className="flex items-center gap-4"></div>

          <div className="absolute left-0/2 flex -translate-x-0/2 items-center gap-0 pl-6 md:left-1/2 md:-translate-x-1/2 md:flex-col md:pl-0">
            <div className="flex items-center gap-4 md:pl-0">
              {!isMobile && (
                <span className="fira-sans-black text-4xl font-semibold text-white drop-shadow-[0_0_5px_rgba(255,100,0,0.3)] select-none">
                  FULL
                </span>
              )}

              {BRAND_CONFIG.animatedEmoji}

              {!isMobile && (
                <span className="fira-sans-black text-4xl font-semibold text-white drop-shadow-[0_0_5px_rgba(255,100,0,0.3)] select-none">
                  FIRE
                </span>
              )}
            </div>

            {!isMobile && (
              <Suspense
                fallback={
                  <div className="h-6 w-32 animate-pulse rounded bg-gray-800" />
                }
              >
                <StoreOpenBanner onNavigate={navigateToSection} />
              </Suspense>
            )}
          </div>

          <ul className="hidden gap-6 md:flex">
            <Suspense
              fallback={
                <div className="h-8 w-full animate-pulse rounded bg-gray-800" />
              }
            >
              <SocialBar />
            </Suspense>
          </ul>

          <MobileNavigation />
        </div>

        <DesktopNavigation />
      </nav>
    </header>
  );
};

export default Header;
